<template>
  <div class="item-float">
    <div v-if="value && display_bar" class="float-bar">
      <div class="out out-min" :style="{ width: `${paint_wear?.wear_min || 0}%` }" />
      <div v-tooltip="getTooltip('factory_new')" class="fn" />
      <div v-tooltip="getTooltip('minimal_wear')" class="mw" />
      <div v-tooltip="getTooltip('field_tested')" class="ft" />
      <div v-tooltip="getTooltip('well_worn')" class="ww" />
      <div v-tooltip="getTooltip('battle_scarred')" class="bs" />
      <div class="out out-max" :style="{ width: `${paint_wear?.wear_max ? (100 - paint_wear.wear_max) : 0}%` }" />
      <span class="caret" :style="caretStyle" />
    </div>
    <div v-if="fade" class="fade-value">{{ $t('market.fade', { value: fade }) }}</div>
    <div class="float-value item-text">{{ value }} <span v-if="float_rank" v-tooltip="{ message: 'Float rank' }" class="float-rank text-cp">[#{{ float_rank }}]</span></div>
    <slot />
  </div>
</template>

<script setup>
import { filters } from '@/hook/market/items.js';
import { APP_ID } from '@common/enum/market.js';
import { roundNumber } from 'bambam-helper/currency.js';
import { computed } from 'vue';
import { translate } from '@/main.js';

const props = defineProps({
  value: [String, Number],
  fade: Number,
  display_bar: {
    type: Boolean,
    default: true,
  },
  float_rank: {
    type: Number,
    default: 0,
  },
  tooltip: {
    type: Boolean,
  },
  fixed: {
    type: Number,
    default: 16,
  },
  paint_id: {
    type: Number,
    default: null,
  },
});

const value = computed(() => {
  if (props.fixed && props.value) {
    return Number(props.value).toFixed(24).slice(0, props.fixed + 2);
  }
  return props.value;
});

const caretStyle = computed(() => ({
  left: `${roundNumber(props.value * 100, 2)}%`,
}));

const paint_wear = computed(() => filters?.[APP_ID.csgo]?.paint_wear?.find((o) => o.id === props.paint_id));

const getTooltip = (name) => {
  if (!props.tooltip) {
    return null;
  }

  const wears = {
    factory_new: { min: 0, max: 0.07 },
    minimal_wear: { min: 0.07, max: 0.15 },
    field_tested: { min: 0.15, max: 0.38 },
    well_worn: { min: 0.38, max: 0.45 },
    battle_scarred: { min: 0.45, max: 1 },
  };

  const fixed = (v) => Number(v).toFixed(2);

  let float_info = '';
  if (paint_wear.value && (paint_wear.value.wear_min > 0 || paint_wear.value.wear_min < 100)) {
    float_info = translate('market.float_limited', { from: fixed(paint_wear.value.wear_min / 100), to: fixed(paint_wear.value.wear_max / 100) });
  }

  return {
    title: `${translate(`market.filter_value.${name}`)}: ${fixed(wears[name].min)} - ${fixed(wears[name].max)}`,
    message_content: float_info,
  };
};
</script>
